'use strict';

const { Future } = require('posterus');
const { isFunction } = require('util');
const Map = require('core-js/library/es6/map');
const { timeout } = require('./utils');

class Readiness {
  constructor() {
    this.state = this.states.PENDING;

    this.future = Future.init(_future => {
      // This allows the consumer of the future to implicitly abort the whole activity.
      // For example, this is called in koa-ring if the client disconnects prematurely.
      return this.deinit.bind(this);
    });

    this.pending = new Map();

    // Readiness check needs to be async. Possible situation: a view component
    // declares itself ready, then renders a child component which becomes
    // unready. If we finish too soon, the child has no chance to delay the
    // process.
    this.tick = new Tick(this.finishIfReady.bind(this), 100);
  }

  hasPending() {
    return Boolean(this.pending.size);
  }

  unready(key, onDeinit) {
    if (this.state === this.states.PENDING) {
      this.pending.set(key, onDeinit);
    }
  }

  ready(key, error) {
    if (this.state === this.states.PENDING) {
      this.pending.delete(key);
      if (error) {
        try {
          this.future.settle(error);
        } finally {
          this.deinit();
        }
      } else {
        this.tick.schedule();
      }
    }
  }

  finishIfReady() {
    if (!this.hasPending()) {
      this.state = this.states.READY;
      this.future.settle();
    }
  }

  deinit() {
    this.tick.deinit();
    const deiniters = Array.from(this.pending.values()).filter(isFunction);
    this.pending.clear();
    flush(deiniters);
  }
}
exports.Readiness = Readiness;

Readiness.prototype.states = {
  PENDING: 'PENDING',
  READY: 'READY'
};

function flush(funs) {
  let error;
  while (funs.length) {
    try {
      funs.shift()();
    } catch (err) {
      error = err;
    }
  }
  if (error) throw error;
}

class Tick {
  constructor(onTick, delay) {
    this.onTick = onTick;
    this.delay = delay;
    this.delay = null;
    this.tick = this.tick.bind(this);
  }

  tick() {
    this.unschedule();
    const { onTick } = this;
    onTick();
  }

  schedule() {
    if (!this.delay) this.delay = timeout(this.delay || 0, this.tick);
  }

  unschedule() {
    if (this.delay) this.delay();
    this.delay = null;
  }

  deinit() {
    this.unschedule();
  }
}



// WEBPACK FOOTER //
// ./src/shared/readiness.js